import $ from '../vendor/jquery';

$('.rte > table').wrap('<div class="table-responsive"/>');
